import { Stack, Typography, Theme } from '@mui/material';
import { InfoMessage } from '../../../../components/common/InfoMessage/InfoMessage';
import { useTranslation } from 'react-i18next';
import { ToPay } from '../../types';
import { useUser } from '../../../../hooks/useUser';

export const PayAmountBlock = ({
  toPay,
  hideBottomText,
}: {
  toPay: ToPay;
  hideBottomText?: boolean;
}) => {
  const { t } = useTranslation();
  const { userBalance } = useUser();

  const formattedBalance = new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(userBalance);

  return (
    <Stack sx={{ gap: { xs: '20px' } }}>
      <InfoMessage
        type="charging"
        bottomText={hideBottomText ? '' : 'orderPage.startCharging'}
        upperText="orderPage.chargingTime"
        chargingTime={toPay.time}
      />
      <Stack
        direction="column"
        sx={(theme: Theme) => ({
          borderRadius: '15px',
          border: `1px solid ${theme.palette.gray[50]}`,
          padding: '12px',
          gap: '12px',
        })}
      >
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="body1" color="common.white">
            {t('orderPage.toPay')}
          </Typography>
          <Typography variant="body1" color="green.main">
            {toPay.amount} ₴
          </Typography>
        </Stack>
        {toPay.serviceFee > 0 && (
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="body2" color="gray.50">
              {t('orderPage.serviceFee')}
            </Typography>
            <Typography variant="body2" color="gray.50">
              {toPay.serviceFee.toFixed(2)} ₴
            </Typography>
          </Stack>
        )}
        {toPay.idleAmount && toPay.idleAmount > 0 ? (
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="body2" color="gray.50">
              {t('orderPage.downtimeFee', { minutes: toPay.idleMinutes ?? 0 })}
            </Typography>
            <Typography variant="body2" color="red.main">
              {toPay.idleAmount.toFixed(2)} ₴
            </Typography>
          </Stack>
        ) : null}
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="body1" color="common.white">
            {t('orderPage.currentBalance')}
          </Typography>
          <Typography variant="body1" color="common.white">
            {formattedBalance} ₴
          </Typography>
        </Stack>
        {toPay.balanceDeduction ? (
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body1" color="common.white">
              {t('orderPage.balanceDeduction')}
            </Typography>
            <Typography variant="body1" color="red.main">
              {toPay.balanceDeduction} ₴
            </Typography>
          </Stack>
        ) : null}
      </Stack>
    </Stack>
  );
};
